import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { STATUS_COLOR_CLASS, type StatusColorTone } from '@/styles/statusColors';

interface PcmpAmountTileProps {
  label: string;
  value: string;
  tone?: StatusColorTone;
  isStruck?: boolean;
  /** A short line under the label, e.g. why the value is struck. */
  note?: ReactNode;
}

export function PcmpAmountTile({
  label,
  value,
  tone,
  isStruck = false,
  note,
}: PcmpAmountTileProps) {
  return (
    <div
      className={cn(
        'flex min-w-0 flex-col gap-0.5 rounded-lg border px-3 py-2',
        tone ? STATUS_COLOR_CLASS[tone] : 'bg-muted/40',
      )}
    >
      <span className={cn('text-base font-semibold tabular-nums', isStruck && 'line-through')}>
        {value}
      </span>
      <span className="truncate text-[11px] font-medium uppercase tracking-wider opacity-80">
        {label}
      </span>
      {note ? <span className="text-xs">{note}</span> : null}
    </div>
  );
}
